import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateDeclineConfirmedPayload {
  shiftId: string;
  professionalId?: string;
  offerId?: string;
  candidateNumber?: number;
  candidateCount?: number;
}

/**
 * Fires when an office confirms the "Decline" action on the Decline offer pop-up
 * Event: dental_portal:confirm_candidate:decline_confirmed
 */
export function fireConfirmCandidateDeclineConfirmed(
  payload: IConfirmCandidateDeclineConfirmedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:decline_confirmed', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
    offer_id: payload.offerId,
    candidate_number: payload.candidateNumber,
    candidate_count: payload.candidateCount,
  });
}
